<template>
    <div class="w-full my-5 border border-gray-200 rounded-xl shadow p-5 flex flex-col">
        <div class="pb-5 flex justify-between">
            <span class="text-xl font-bold">
                {{ props.title }}
            </span>
            <hts-form-button
                color="main"
                icon-name="hi-chart-pie-icon"
                icon-position="right"
                type="submit">
                {{ $t('labels.viewStatic') }}
            </hts-form-button>
        </div>
        <div class="flex items-center gap-1 mb-5">
            <div
                v-for="(item, index) in sampleTabs"
                :key="index"
                class="p-3 rounded-md cursor-pointer border border-transparent"
                :class="[item.isActive ? 'border bg-gray-200 p-3 rounded-md cursor-pointer' : '']"
                @click="handleClick(index)">
                <span class="text-base font-medium">
                    {{ item.title }}
                </span>
            </div>
        </div>
        <div class="h-full">
            <hts-chart-line
                :datasets="datasets"
                :labels="labels"
                :chart-options="chartOptions" />
        </div>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  amount: {
    type: String,
    default: ''
  }
})
const sampleTabs = reactive([
  {
    title: '12 tháng',
    isActive: true
  },
  {
    title: '3 tháng',
    isActive: false
  },
  {
    title: '1 tháng',
    isActive: false
  },
  {
    title: '7 ngày',
    isActive: false
  },
  {
    title: '1 ngày',
    isActive: false
  }
])
const datasets = [
  {
    borderColor: '#0891B2',
    data: [15, 10, 25, 20, 35, 30, 45, 40, 55, 50, 65, 60],
    lineTension: 0.5,
    pointRadius: 0
  },
  {
    borderColor: '#22D3EE',
    data: [10, 5, 15, 10, 20, 15, 25, 20, 30, 25, 35, 30],
    lineTension: 0.5,
    pointRadius: 0
  }
]
const labels = ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12']
const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      grid: {
        display: false
      }
    },
    y: {
      ticks: {
        display: false
      }
    }
  }
}
const handleClick = (index: number) => {
  sampleTabs.map((element: any) => {
    element.isActive = false
    return element
  })
  sampleTabs[index].isActive = true
}
</script>
